import React, { useState } from 'react'

const InnerPageNav = () => {

  return (
    <div
    data-collapse="medium"
    data-animation="over-right"
    data-duration={400}
    data-easing="ease"
    data-easing2="ease"
    role="banner"
    className="navigation w-nav"
  >
    <div className="nav-content-wrapper">
      <a
        href="/#home"
        id="w-node-_546ee260-b360-fdef-8657-23f305731f0b-a2718ffa"
        className="brand w-nav-brand"
      >
        <img
          src="images/cloudaxcolorwhite.svg"
          alt="growkit template logo"
          className="logo logoheader"
        />
      </a>
      <nav role="navigation" className="nav-links-wrapper w-nav-menu">
        <div className="nav-links">
          <a href="/#home" className="nav-link">
            Home
          </a>
          <a href="/#about" className="nav-link">
            About
          </a>
          <a href="/#roadmap" className="nav-link">
            Roadmap
          </a>
          <a href="/#teamsection" className="nav-link">
            Team
          </a>
          <a href="tokenomics" className="nav-link">
          Token Info
          </a>
          <a href="ecosystem" className="nav-link">
          Ecosystem
          </a>
          <a href="faq" className="nav-link">
            FAQs
          </a>
          <div
            data-hover="false"
            data-delay={10}
            className="nav-dropdown w-dropdown"
          >
            <div className="nav-link w-dropdown-toggle">
              <div>Community</div>
            </div>
            <div className="nav-dropdown-list w-dropdown-list">
              <a href="https://t.me/cloudaxofficial" target="_blank" className="nav-link">
                Telegram
              </a>
              <a href="https://twitter.com/CloudaxHQ" target="_blank" className="nav-link">
                Twitter
              </a>
              <a href="https://cloudax.medium.com/" target="_blank"className="nav-link">
                Medium
              </a>
              <a href="/#" className="nav-link">
                <span className="color-text-gradient">KingsChat</span>
              </a>
              <a href="https://www.cloudax.io/" target="_blank"className="nav-link">
              Github
              </a>
            </div>
          </div>
          <div className="mobile-only-links">
            <a href="https://launchpad.cloudax.io/" target="_blank" className="button w-button">
              Join Presale
            </a>
          </div>
        </div>
      </nav>
      <div
        id="w-node-_546ee260-b360-fdef-8657-23f305731f27-a2718ffa"
        className="button-group nav-buttons"
      >
  
        <div className="nav-cta">
          <a
            id="w-node-_546ee260-b360-fdef-8657-23f305731f2b-a2718ffa"
            href="https://launchpad.cloudax.io/"
            target="_blank"
            className="button nav-cta w-button"
          >
            <span>Join Presale</span>
          </a>
        </div>
        <div
          id="w-node-_546ee260-b360-fdef-8657-23f305731f2e-a2718ffa"
          className="button secondary menu w-nav-button"
        >
          <div className="secondary-button-text">Menu</div>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default InnerPageNav